export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-background-e81691780bd2978299ba44ba7c5eac70.png";